import { useEffect, useState } from "react";
import { loadcompanyDetail } from "../services/companyDetailService";

const useLoadCompanyDetailById = () => {
    const [companyDetails, setCompanyDetail] = useState([]);
    const [isLoad, setIsLoad] = useState(false);

    const fetchVendorDetail = async () => {
        const para = { p_companyid: localStorage.getItem("companyid"), p_plantid: 1 };
        try {
            const data = await loadcompanyDetail(para);
            if (data && data.length > 0) {
                setCompanyDetail(data);
            }
        } catch (error) {
            // CallMessage("error", error.message, "Error");
        }
    }

    useEffect(() => {
        if (!isLoad) {
            fetchVendorDetail();
        }
    }, [isLoad])


    const loadCompanyDetail = async (vendorID) => {
        await fetchVendorDetail(vendorID);
    }

    return { companyDetails, setCompanyDetail, loadCompanyDetail };

}
export default useLoadCompanyDetailById;